import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { OidcToken } from './OidcToken';
export class OidcAccessToken extends OidcToken {
  constructor(token) {
    super(typeof token === 'string' ? token.replace(/^Bearer /, '') : token);

    _defineProperty(this, "toString", () => `Bearer ${this.token}`);
  }

}
//# sourceMappingURL=OidcAccessToken.js.map